import React, { useState, useEffect } from "react";
import Map from "../map/Map";
import LoadingIcon from "../icons/loadingIcon";
import notification from "../utilities/notification";
import FeedPanel from "../feed/FeedPanel";

const Home = ({
  currentUser,
  loaded,
  locationMode,
  modalIsOpen,
  notificationId,
  postId,
  posts,
  selected,
  setErrors,
  setLoaded,
  setLocationMode,
  setMapLoaded,
  setNotificationId,
  setPosts,
  setSelected,
  setShowMenu,
  setShowSearch,
  showSearch,
}) => {
  const [center, setCenter] = useState({
    lat: 51.57686944,
    lng: -0.00912222,
  });

  const url = `${process.env.REACT_APP_HOST}/api/v1/posts`;

  const geoLocateUser = () => {
    if (navigator && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const latitude = parseFloat(position.coords.latitude);
        const longitude = parseFloat(position.coords.longitude);
        setCenter({ lat: latitude, lng: longitude });
        notification("Current location found", "info", 3000);
      });
    }
  };

  useEffect(() => {
    fetch(url)
      .then((response) => {
        if (response.ok) {
          response.json().then((response) => {
            setPosts(response.data);
            setLoaded(true);
            geoLocateUser();
          });
        } else {
          response.json().then((data) => {
            console.error("Error:", data);
          });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }, [setLoaded, setPosts, url]);

  return (
    <>
      {!loaded ? (
        <LoadingIcon type="bars" />
      ) : (
        <div className="home">
          <FeedPanel />
          <Map
            center={center}
            currentUser={currentUser}
            loaded={loaded}
            locationMode={locationMode}
            modalIsOpen={modalIsOpen}
            notificationId={notificationId}
            postId={postId}
            posts={posts}
            selected={selected}
            setErrors={setErrors}
            setLocationMode={setLocationMode}
            setMapLoaded={setMapLoaded}
            setNotificationId={setNotificationId}
            setPosts={setPosts}
            setSelected={setSelected}
            setShowMenu={setShowMenu}
            setShowSearch={setShowSearch}
            showSearch={showSearch}
          />
        </div>
      )}
    </>
  );
};

export default Home;
